import React from 'react';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';


export default class SmartTag extends React.Component {

  render() {
    const { tag, ...chipProps } = this.props;
    const tagName = tag.name || '';
    const tagInitials = tagName.length > 1 ? tagName.substr(0, 2) : '';
    const avatarProps = {
      size: 32,
      style: {
        textTransform: 'capitalize',
      },
    };
    let avatar = (<Avatar {...avatarProps} src={tag.icon} />);
    if (!tag.icon) {
      avatar = (<Avatar {...avatarProps}>{tagInitials}</Avatar>);
    }
    return (
      <Chip {...chipProps}>{avatar}{tagName}</Chip>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/SmartTag.jsx